<template>
  <div class="bodywarp">
    <el-card class="box-card boxcard" style="min-height:calc(100% - 30px)">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="公司名称">
          <el-select v-model="formInline.cztcode" clearable placeholder="请选择">
            <el-option v-for="item in selectlist" :key="item.ccorpcode" :label="item.ccorpname" :value="item.ccorpcode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="汇总单号">
          <el-input v-model="formInline.ccode" placeholder="汇总单号"></el-input>
        </el-form-item>

        <el-form-item label="违规日期">
          <el-date-picker v-model="formInline.ddata" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <Debounce :time='300' :isDebounce="1">
            <el-button type="primary" @click.native="OpPurchaseorderUrgencyList" size="medium">查询</el-button>

          </Debounce>
          <el-button type="primary" size="medium" @click="exportExcel()">导出</el-button>
        </el-form-item>
      </el-form>

      <div class="text item text-center">
        <div class="pull-right" style="margin-bottom:15px">
          <!-- <el-button type="success" size="medium">填写运费</el-button>
          <el-button type="info" size="medium">填写送货截止日期</el-button> 
          <el-button type="primary" size="medium">报价</el-button>
          <el-button type="warning" size="medium" icon="el-icon-aim">记录</el-button>-->
        </div>
        <el-table :data="tableData1" id="out-table" max-height="560" style="width: 100%" class="tablecenter" show-summary :summary-method="getSummaries" border :cell-style="{ padding: '7px 0' }" :header-cell-style="{ background: '#eef1f6'}" :row-class-name="tableRowClassName">
          <!-- 紧急普通 -->
          <!-- <el-table-column prop="curgent" label="类型" width="100"></el-table-column> -->
          <!-- <el-table-column prop="curgent" label="类型" width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.curgent">
                <el-tag type="primary" size="small" v-if="scope.row.curgent=='普通'">{{scope.row.curgent}}</el-tag>
                <el-tag type="danger" size="small" v-if="scope.row.curgent=='紧急'" effect="dark">{{scope.row.curgent}}</el-tag>
              </span>
            </template>
          </el-table-column> -->
          <el-table-column prop="cztname" label="公司信息" width="200"></el-table-column>
          <!-- 判断时间 -->
          <!-- <el-table-column prop="ddhdate" label="要货时间" width="120" /> -->
          <el-table-column prop="ddata" label="违规日期" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.ddata">
                {{scope.row.ddata.substring(0,10)}}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="cinvclasscode" label="分类编号" min-width="100" />
          <el-table-column prop="cinvclassname" label="分类名称" min-width="150" />
          <el-table-column prop="ctypecode" label="违规项目编号" min-width="200" />
          <el-table-column prop="ctype" label="违规项目" width="90" />
          <el-table-column prop="icount" label="违规次数" width="90" />
          <el-table-column prop="icounts" label="允许违规次数" width="120" />
          <el-table-column prop="iday" label="违规天数" width="110" />
          <!-- <el-table-column prop="itaxeprice_list" label="含税单价" width="90" />
          <el-table-column prop="itaxe_list" label="税额" width="50px" />
          <el-table-column prop="imoney" label="订单金额" width="90" />
          <el-table-column prop="cremarklist" label="备注" min-width="120" />
          <el-table-column prop="dsenddate" label="订单下发时间" width="110">
            <template slot-scope="scope">
              <span v-if="scope.row.dsenddate">
                {{scope.row.dsenddate.substring(0,10)}}
              </span>
            </template>
          </el-table-column> -->
          <!-- <el-table-column  label="操作" width="150">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" plain @click="read(scope.row)">查看</el-button>
        </template>
       </el-table-column> -->
        </el-table>
      </div>
      <div class="pull-right" style="padding:20px;padding-bottom:20px;">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10,20, 50, 100, 1000]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
      </div>
    </el-card>

  </div>
</template>

<script>
import FileSaver from "file-saver";
import XLSX from "xlsx";
export default {
  data() {
    return {
      formInline: {
        cztcode: "",
        ccode: "",
        ddeliverytime: [],
      },
      tableData1: [],
      // 牧场
      selectlist: {},
      // 分页
      pageSize: 10,
      pageIndex: 1,
      // 页数
      totalCount: 0,
      bbbg: false,
    };
  },
  created() {
    this.OpPurchaseorderUrgencyList();
    this.GetAccountInfo();
  },
  methods: {
    //定义导出Excel表格事件
    exportExcel() {
      /* 从表生成工作簿对象 */
      var wb = XLSX.utils.table_to_book(document.querySelector("#out-table"), {
        raw: true,
      });
      /* 获取二进制字符串作为输出 */
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
      });
      try {
        FileSaver.saveAs(
          //Blob 对象表示一个不可变、原始数据的类文件对象。
          //Blob 表示的不一定是JavaScript原生格式的数据。
          //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
          //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
          new Blob([wbout], { type: "application/octet-stream" }),
          //设置导出文件名称
          "订单执行.xlsx"
        );
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
      }
      return wbout;
    },
    // 求和
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (index === 1) {
          sums[index] = "";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));

        if (
          index == 7 ||
          index == 8 ||
          index == 9 ||
          index == 11 ||
          index == 12
        ) {
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] += "";
          } else {
            sums[index] = "N/A";
          }
        }
      });

      return sums;
    },
    // 获取table 信息
    OpPurchaseorderUrgencyList() {
      console.log(this.formInline);

      var starttime;
      var endtime;
      if (this.formInline.ddeliverytime != null) {
        if (this.formInline.ddeliverytime.length != 0) {
          starttime = this.formInline.ddeliverytime[0];
          endtime = this.formInline.ddeliverytime[1];
        } else {
          starttime = "";
          endtime = "";
        }
      } else {
        starttime = "";
        endtime = "";
      }
      this.$axios({
        method: "post",
        url: "CommonModule/Op_Supplier/GetViolationHistoryList",
        //data: this.formInline,
        data: {
          startDate: starttime,
          endDate: endtime,
          cztcode: this.formInline.cztcode,
          ccode: this.formInline.ccode,
          pageSize: this.pageSize,
          pageIndex: this.pageIndex,
        },
      }).then((res) => {
        console.log(res);
        if (res.data.Data.rows) {
          this.tableData1 = res.data.Data.rows;
          this.totalCount = res.data.Data.totalCount;
        }
      });
    },
    // 获取公司信息
    GetAccountInfo() {
      this.$axios({
        method: "post",
        url: "CommonModule/Op_StoreAndInvoice/GetAccountInfo",
      }).then((res) => {
        console.log(res);
        if (res.data.Success) {
          if (res.data.Message) {
            this.selectlist = res.data.Data;
          }
        } else {
          this.$message.error(res.data.Message);
        }
      });
    },
    //是否版本变更，是变换行颜色
    tableRowClassName({ row }) {
      console.log(row, "获取信息结果");
      // if (row.cversionup == "是") {
      //   return "success-row";
      // }
      if (row.cversionup == "") {
        return "success-row";
      }
      return "";
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.OpPurchaseorderUrgencyList();
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.OpPurchaseorderUrgencyList();
    },
  },
};
</script>
<style>
  .el-table .success-row {
    background: #59ff00;
  }
</style>

